<template>
    <div :class="containerClassName">
        <slot></slot>
    </div>
</template>

<script>
    import '@fancyapps/fancybox';

    export default {
        props: {
            containerClassName: {
                type: String,
                default: ''
            },
            selector: {
                type: String,
                default: '[data-gallery]'
            },
            group: {
                type: String,
                default: 'gallery'
            },
            loop: {
                type: [String, Number, Boolean],
                default: false
            }
        },
        data() {
            return {

            };
        },
        mounted() {
            const items = this.getImages();

            for( const item of items ) {
                $( item ).attr('data-fancybox', this.group);
            }

            $( items ).fancybox({
                loop: !!+this.loop
            });
        },
        methods: {
            getImages() {
                return $( this.$el ).find( this.selector );
            }
        }
    }
</script>
